module.exports = (Promise.resolve(__parcel__require__("./" + "module.108e3c43.db32f15e.js"))).then(() => parcelRequire('fdcGF'));